import { FundBasketOverview } from "@funds/pages/fund-basket-overview";
import { createFileRoute } from "@tanstack/react-router";
import {
  fundBasketAnalyticsQueryOptions,
  fundBasketChartQueryOptions,
  fundBasketQueryOptions,
} from "creso-core/hooks";

export const Route = createFileRoute(
  "/(auth)/_headed/funds/basket/$basket_id/"
)({
  loader: async ({ context, params }) => {
    const { queryClient } = context;

    const fundBasket = queryClient.ensureQueryData(
      fundBasketQueryOptions(params.basket_id)
    );

    const analytics = queryClient.ensureQueryData(
      fundBasketAnalyticsQueryOptions({
        id: params.basket_id,
        benchmark: "NIFTY 500",
      })
    );

    const chartData = queryClient.ensureQueryData(
      fundBasketChartQueryOptions({
        id: params.basket_id,
        period: "1Y",
      })
    );

    return {
      basket: await fundBasket,
      analytics: await analytics,
      chartData: await chartData,
    };
  },
  component: FundBasketOverview,
});
